import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Photo, SelectModal } from "./ManageChannelsStyles";
import RadioInput from "components/global/RadioInput";
import Loader from "components/global/Loader";
import ImgWrapper from "components/global/ImgWrapper";
import Spacer from "components/global/Spacer";
import { axiosInstance } from "api";
import { showAlert } from "utils/utils";
import userIcon from "assets/icons/userIconWhite.svg";
import { socialIcons } from "./ManageChannels";

// const testAccounts = [
//   { name: "test1", id: "12131", category: "company" },
//   { name: "test2", id: "12314", category: "company" },
//   { name: "test3", id: "12315", category: "company" },
//   { name: "test4", id: "12316", category: "company" },
//   { name: "test5", id: "12317", category: "company" },
//   { name: "test6", id: "12318", category: "company" },
//   { name: "test7", id: "12319", category: "company" },
//   { name: "test8", id: "12310", category: "company" },
//   { name: "test9", id: "123100", category: "company" },
//   { name: "mine", id: "121111", category: "personal" },
// ];

const SelectAccountModal = ({
  brand,
  path,
  loadSocials = () => null,
}) => {
  const router = useHistory();
  const { search } = useLocation();
  const platform = new URLSearchParams(search).get("platform");
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState();
  const [fetchingAccounts, setFetchingAccounts] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const getAccounts = useCallback(async () => {
    if (!brand?.id) return;
    try {
      let res = await axiosInstance.get(
        `${platform}/${brand?.id}/pages/get`
      );

      if (res.data.status === false) {
        showAlert({
          msg: res.data.message,
          type: "danger",
        });
      } else {
        setAccounts(res.data.data);
        res.data.data?.forEach((account) => {
          if (account.selected) {
            setSelectedAccountId(
              platform === "instagram" ? account.ig_id : account.id
            );
          }
        });
      }
      setFetchingAccounts(false);
    } catch (e) {
      showAlert({
        msg: "Error. Could not get accounts",
        type: "danger",
      });
      setFetchingAccounts(false);
      console.log(e);
    }
    // eslint-disable-next-line
  }, [brand]);

  const handleSelectAccount = (accountId) => {
    if (!accountId) return;
    setSelectedAccountId(accountId);
  };

  const handleSubmitAccount = useCallback(
    async (e) => {
      e.preventDefault();

      let data = [];

      data = accounts.filter((item) => {
        if (item.ig_id) {
          return item.ig_id === selectedAccountId;
        }
        return item.id === selectedAccountId;
      });

      if (data.length > 0) {
        setSubmitting(true);

        try {
          let res = await axiosInstance.post(
            `${platform}/${brand?.id}/page/store`,
            { accounts: data }
          );
          if (res.data.status === false) {
            showAlert({
              msg: res.data.message ?? "An error occurred.",
              type: "danger",
            });
          } else {
            router.push(`${path}?success=${res.data.message}`);
            await loadSocials();
          }
          setSubmitting(false);
        } catch (e) {
          setSubmitting(false);
          showAlert({
            msg: e.response.data.message || "An error occurred. Try again",
            type: "danger",
          });
        }
      } else {
        showAlert({
          msg: "You must make at least one selection",
          type: "danger",
        });
      }

      data = [];
    },
    // eslint-disable-next-line
    [platform, accounts, selectedAccountId]
  );

  useEffect(() => {
    if (brand) {
      getAccounts();
    }
    // eslint-disable-next-line
  }, [brand]);

  return (
    <SelectModal className="selectModal show">
      <form className="card" onSubmit={(e) => handleSubmitAccount(e)}>
        <div className="cardBody">
          <h5>Which channel would you like to add?</h5>
          <Spacer y={0.6} />
          <p className="l2 colorBodyText">
            Select one social media channel you want to add to PostPaddy.
          </p>
          <Spacer y={2.4} />
          {fetchingAccounts && <Loader type="spinner" />}
          {!fetchingAccounts && !accounts.length && (
            <p className="l3 colorGrey1">No channels available.</p>
          )}
          {platform === "instagram" &&
            accounts.length >= 1 &&
            accounts.map((item, index) => (
              <div key={index} className="flexRow alignCenter chooseTargetItem">
                <RadioInput
                  id={`_${item.ig_id}`}
                  name="instagram_account"
                  value={item.ig_id}
                  checked={selectedAccountId === item.ig_id}
                  onClick={() => handleSelectAccount(item.ig_id)}
                />
                <Spacer x={1.2} />
                <label
                  htmlFor={`_${item.ig_id}`}
                  className="flexRow alignCenter"
                >
                  <Photo className="small">
                    <ImgWrapper
                      size={3.6}
                      imgHeight={"100%"}
                      className="imgWrapper"
                    >
                      <img src={item.profile_picture || userIcon} alt="avi" />
                    </ImgWrapper>
                    <img
                      src={socialIcons.circle["instagram"]}
                      className="icon platformImg"
                      alt="icon"
                    />
                  </Photo>
                  <Spacer x={1.2} />
                  <span className="text l3 colorBodyText">{item.username}</span>
                </label>
              </div>
            ))}
          {platform === "facebook" &&
            accounts.length >= 1 &&
            accounts.map((item, index) => (
              <div key={index} className="flexRow alignCenter chooseTargetItem">
                <RadioInput
                  id={`_${item.id}`}
                  name="facebook_page"
                  value={item.id}
                  checked={selectedAccountId === item.id}
                  onClick={() => handleSelectAccount(item.id)}
                />
                <Spacer x={1.2} />
                <label htmlFor={`_${item.id}`} className="flexRow alignCenter">
                  <Photo className="small">
                    <ImgWrapper
                      size={3.6}
                      imgHeight={"100%"}
                      className="imgWrapper"
                    >
                      <img src={item.profile_picture || userIcon} alt="avi" />
                    </ImgWrapper>
                    <img
                      src={socialIcons.circle["facebook"]}
                      className="icon platformImg"
                      alt="icon"
                    />
                  </Photo>
                  <Spacer x={1.2} />
                  <span className="text l3 colorBodyText">{item.name}</span>
                </label>
              </div>
            ))}
          {platform === "linkedin" && (
            <>
              <p className="colorGrey1 body-2 bold">LinkedIn profile</p>
              <Spacer y={1.2} />
              {accounts.length >= 1 &&
                accounts
                  .filter((item) => item.category === "personal")
                  .map((item, index) => (
                    <div
                      key={index}
                      className="flexRow alignCenter chooseTargetItem"
                    >
                      <RadioInput
                        id={`_${item.id}`}
                        name="linkedin_account"
                        value={item.id}
                        checked={selectedAccountId === item.id}
                        onClick={() => handleSelectAccount(item.id)}
                      />
                      <Spacer x={1.2} />
                      <label
                        htmlFor={`_${item.id}`}
                        className="flexRow alignCenter"
                      >
                        <Photo className="small">
                          <ImgWrapper
                            size={3.6}
                            imgHeight={"100%"}
                            className="imgWrapper"
                          >
                            <img
                              src={item.profile_picture || userIcon}
                              alt="avi"
                            />
                          </ImgWrapper>
                          <img
                            src={socialIcons.circle["linkedin"]}
                            className="icon platformImg"
                            alt="icon"
                          />
                        </Photo>
                        <Spacer x={1.2} />
                        <span className="text l3 colorBodyText">
                          {item.name}
                        </span>
                      </label>
                    </div>
                  ))}
              <div className="divider"></div>
              <p className="colorGrey1 body-2 bold">LinkedIn page</p>
              <Spacer y={1.2} />
              {accounts.length >= 1 &&
                accounts
                  .filter((item) => item.category === "company")
                  .map((item, index) => (
                    <div
                      key={index}
                      className="flexRow alignCenter chooseTargetItem"
                    >
                      <RadioInput
                        id={`_${item.id}`}
                        name="linkedin_account"
                        value={item.id}
                        checked={selectedAccountId === item.id}
                        onClick={() => handleSelectAccount(item.id)}
                      />
                      <Spacer x={1.2} />
                      <label
                        htmlFor={`_${item.id}`}
                        className="flexRow alignCenter"
                      >
                        <Photo className="small">
                          <ImgWrapper
                            size={3.6}
                            imgHeight={"1.6rem"}
                            className="imgWrapper"
                          >
                            <img
                              src={item.profile_picture || userIcon}
                              alt="avi"
                            />
                          </ImgWrapper>
                          <img
                            src={socialIcons.circle["linkedin"]}
                            className="icon platformImg"
                            alt="icon"
                          />
                        </Photo>
                        <Spacer x={1.2} />
                        <span className="text l3 colorBodyText">
                          {item.name}
                        </span>
                      </label>
                    </div>
                  ))}
            </>
          )}
        </div>
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween actionBtns">
          <button
            type="button"
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() => {
              router.push(path);
              document.querySelector(".selectModal").classList.remove("show");
            }}
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            type="submit"
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={submitting || !accounts.length}
          >
            {submitting ? <Loader type="spinner" /> : "Continue"}
          </button>
        </div>
      </form>
    </SelectModal>
  );
};

export default SelectAccountModal;
